import { useCallback, useState } from 'react';
import LeadsService from 'src/services/leads';

const useLeadsService = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);

  const getCallbackMetaLeadsService = useCallback(
    async (code: string, customerId: number) => {
      try {
        if (code == "" || code == undefined) {
          return;
        }
        setIsLoading(true);
        const response = await LeadsService.getCallbackMetaLeads(
          code,
          customerId
        );
        setIsLoading(false);
        return response;
      } catch (error: any) {
        setIsLoading(false);
        // Loga o erro mas não quebra a aplicação
        console.error('Erro ao buscar callback dos leads', error);
        // Retorna undefined para indicar que não foi possível processar
        return undefined;
      }
    },
    []
  );

  const getUrlMetaLeadsService = useCallback(async (customer_id: number) => {
    try {
      setIsLoading(true);
      const response = await LeadsService.getUrlMetaLeads(customer_id);
      setIsLoading(false);
      return response;
    } catch (error) {
      console.error('Erroao buscar status dos leads', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const getStatusLeadsService = useCallback(async (customerId: number) => {
    try {
      setIsLoading(true);
      const response = await LeadsService.getStatusLeads(customerId);
      setIsLoading(false);
      return response;
    } catch (error: any) {
      setIsLoading(false);
      // Se for erro 404 (endpoint não existe), retorna uma resposta padrão
      // em vez de quebrar a aplicação
      if (error?.response?.status === 404) {
        console.warn('Endpoint de status de leads não disponível (404)');
        return {
          status: 200,
          data: { status: 'NotConnected' }
        };
      }
      // Para outros erros, apenas loga mas não quebra a aplicação
      console.error('Erro ao buscar status dos leads', error);
      return {
        status: 200,
        data: { status: 'NotConnected' }
      };
    }
  }, []);

  const deleteMetaLeadsService = useCallback(async (customerId: number) => {
    try {
      setIsLoadingDelete(true);
      const response = await LeadsService.deleteMetaLeads(customerId);
      setIsLoadingDelete(false);
      return response;
    } catch (error) {
      console.error('Erro ao deletar leads', error);
      throw error;
    } finally {
      setIsLoadingDelete(false);
    }
  }, []);

  return {
    getCallbackMetaLeadsService,
    getUrlMetaLeadsService,
    getStatusLeadsService,
    deleteMetaLeadsService,
    isLoading,
    isLoadingDelete,
  };
};

export default useLeadsService;
